import React from "react";
import selectdropdownsvg from "../../../images/selectdropdownsvg.svg";
import whiteselectdown from "../../../images/whiteselectdown.svg";

const SortingControl = ({ isDarkMode, sortOption, setSortOption }) => {
  // Handle sort option change
  const handleSortChange = (e) => {
    setSortOption(e.target.value);
  };

  return (
    <select
      className="rounded-md bg-[#EFEFEF] dark:bg-darktitleColor py-2 px-[11px] s18:p-[9px_11px] w-[247px] border-none outline-none text-[#6B7280] dark:text-white text-xs md:text-sm font-normal leading-[114%] appearance-none max-md:mx-1"
      value={sortOption}
      onChange={handleSortChange}
    >
      <option value="league">Sort by league</option>
      <option value="time">Sort by time</option>
    </select>
  );
};

export default SortingControl;
